import React from 'react';

export default function CardTableContent(props: { children?: React.ReactNode; className?: string }) {
  return <div className={props.className}>{props.children}</div>;
}
